import React, { CSSProperties, useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import "./input.scss";
import { InputAdornment } from "@material-ui/core";
import { useDebounce } from "../../functions";

interface InputProps {
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  errorText?: string;
  width?: string;
  autoFocus?: boolean;
  size?: "medium" | "small";
  type?: string;
  value?: string | null;
  required?: boolean;
  onChange: Function;
  onBlur: Function;
  min?: number;
  max?: number;
  style?: CSSProperties;
  icon?: {
    position: "end" | "start";
  };
  defaultValue: string;
  onKeyPress: Function;
  startIcon?: React.ReactElement;
  endIcon?: React.ReactElement;
  disabledDebouncing: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  openPopover: boolean;
}

const Input = ({
  placeholder,
  disabled = false,
  startIcon,
  endIcon,
  error = false,
  icon,
  errorText = "",
  width = "150px",
  autoFocus = false,
  size = "medium",
  type = "",
  value = null,
  required = false,
  onChange = (value) => value,
  onBlur = (value) => value,
  min,
  max,
  style,
  defaultValue,
  onKeyPress = () => {},
  disabledDebouncing,
  inputRef,
  openPopover = false,
  ...props
}: InputProps) => {
  const [inputValue, setInputValue] = useState(defaultValue || "");
  const debouncedInputValue = useDebounce(inputValue, 400);

  if (openPopover) {
    inputRef.current?.focus();
  }

  useEffect(() => {
    if (debouncedInputValue || debouncedInputValue === "") {
      onChange(debouncedInputValue);
    }
  }, [debouncedInputValue]);

  return (
    <TextField
      {...props}
      className={size === "medium" ? "textfield" : "textfield small"}
      style={{
        width: width,
        ...style,
      }}
      inputRef={inputRef}
      defaultValue={defaultValue}
      disabled={disabled}
      autoFocus={autoFocus}
      value={value}
      error={error}
      type={type}
      placeholder={placeholder}
      variant="outlined"
      helperText={errorText}
      required={required}
      onChange={(e) =>
        disabledDebouncing
          ? onChange(e.target.value)
          : setInputValue(e.target.value)
      }
      onBlur={(e) => onBlur(e)}
      onKeyPress={onKeyPress}
      InputProps={{
        startAdornment: startIcon && (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ),
        endAdornment: endIcon && (
          <InputAdornment position="end">{endIcon}</InputAdornment>
        ),
      }}
    />
  );
};

export default Input;
